import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SubwayIcon(props: IconProps) {
    return <Icon {...props} iconKey={"subway"}/>
}
